export const formatFollowers = (n: number) =>
  n >= 1000 ? `${Math.round(n / 100) / 10}k Seguidores` : `${n} Seguidores`;
